module.exports = __webpack_public_path__ + "static/media/book.028978f4.jpg";